"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatNumber = void 0;
var formatNumber = exports.formatNumber = function formatNumber(_ref) {
  var value = _ref.value,
    _ref$minDecimals = _ref.minDecimals,
    minDecimals = _ref$minDecimals === void 0 ? 2 : _ref$minDecimals,
    _ref$maxDecimals = _ref.maxDecimals,
    maxDecimals = _ref$maxDecimals === void 0 ? 2 : _ref$maxDecimals,
    _ref$grouping = _ref.grouping,
    grouping = _ref$grouping === void 0 ? true : _ref$grouping,
    _ref$empty = _ref.empty,
    empty = _ref$empty === void 0 ? '---' : _ref$empty;
  if (value === undefined) {
    return empty;
  }
  return value.toLocaleString(undefined, {
    useGrouping: grouping,
    minimumFractionDigits: minDecimals,
    maximumFractionDigits: maxDecimals
  });
};